enum ViewType {
  Grid = 'grid',
  List = 'list',
}

export default ViewType;
